import { Text } from '@pinchenterprisesnpm/friday-ui'
import { ISuggestedPayRateStrategy } from '@network/models/suggested-pay-rates.model'
import { IStrategySelectionShiftParams } from '@src/features/shift-post-v2/components/smart-pay/smart-pay.types'
import { getSelectedPayRateStrategy } from '@src/features/shift-post-v2/components/smart-pay/smart-pay.utils'
import { ProTipSegmentContainer } from './pro-tip-segment.style'

interface IProTipSegmentProps {
  mt?: string
  regularStrategy: ISuggestedPayRateStrategy
  lastMinuteStrategy: ISuggestedPayRateStrategy
  strategySelectionParams: IStrategySelectionShiftParams
}

const ProTipSegment = ({
  regularStrategy,
  lastMinuteStrategy,
  strategySelectionParams,
  mt,
}: IProTipSegmentProps) => {
  const selectedPayRateStrategy = getSelectedPayRateStrategy(
    regularStrategy,
    lastMinuteStrategy,
    strategySelectionParams,
  )
  const recommendedPay = selectedPayRateStrategy.pay_rate

  return (
    <ProTipSegmentContainer mt={mt}>
      <Text color="primary" fontWeight="semiBold" mt="0">
        💡 Pro Tip
      </Text>

      <Text my="xs" color="secondary">
        • Shifts with rates above ${recommendedPay}/hr fill <b>3x faster</b>
      </Text>
      <Text my="xs" color="secondary">
        • Higher rates attract more experienced workers
      </Text>
      <Text mt="xs" mb="0" color="secondary">
        • Competitive pay reduces no-show rates by up to 40%
      </Text>
    </ProTipSegmentContainer>
  )
}

export default ProTipSegment
